import * as types from "../constants/actionTypes";

export const setSelectedHotel = id => {
  return {
    type: types.SELECTED_HOTEL_ID,
    payload: id
  };
};

export const setSelectedRegion = id => {
  return {
    type: types.SELECTED_REGION_ID,
    payload: id
  };
};

export const setSelectedCity = id => {
  return {
    type: types.SELECTED_CITY_CODE,
    payload: id
  };
};

export const setSelectedDeal = id => {
  return {
    type: types.SELECTED_DEAL_ID,
    payload: id
  };
};



// WEBPACK FOOTER //
// ./src/actions/hotelsActions.js